import { Week } from "PFApp/booking/parts/overview/context/use_calendar_days";
import { ZoomMode } from "PFApp/booking/types/zoom_mode";
import React from "react";

import { useCalendarHeader } from "../use_calendar_header";
import { WeekItem } from "./week_item/week_item";
import css from "./weeks.module.scss";

type WeeksProps = {
  weeks: Week[];
  zoomMode: ZoomMode;
};

export const Weeks = ({ weeks, zoomMode }: WeeksProps): JSX.Element => {
  const { weeksHeight } = useCalendarHeader();

  return (
    <div className={css.root} style={{ height: weeksHeight }}>
      {weeks.map((week) => (
        <WeekItem key={`week_${week.startDate.getTime()}`} week={week} zoomMode={zoomMode} />
      ))}
    </div>
  );
};
